import { render, staticRenderFns } from "./migrationpencairandana.vue?vue&type=template&id=2108f5c3&scoped=true&"
import script from "./migrationpencairandana.vue?vue&type=script&lang=js&"
export * from "./migrationpencairandana.vue?vue&type=script&lang=js&"
import style0 from "./migrationpencairandana.vue?vue&type=style&index=0&id=2108f5c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2108f5c3",
  null
  
)

export default component.exports